import SectionTitle from "../components/SectionTitle";
import ProjectCard from "../components/ProjectCard";
import ProjectsIcon from "../components/icons/ProjectsIcon";
import { motion } from "framer-motion";
import { projectsData } from "../data/projects-data";

export default function ProjectsSection() {
  return (
    <motion.section
      initial={{ x: "-100%" }}
      animate={{ x: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="w-full py-5 px-3 sm:px-5"
      id="projects"
    >
      <SectionTitle title="Projects">
        <ProjectsIcon />
      </SectionTitle>

      <div className="flex flex-col items-center pb-4">
        <p className="text-base font-medium tabular-nums text-portfolio-muted">
          {projectsData.length === 1
            ? `${projectsData.length} Project`
            : `${projectsData.length} Projects`}
        </p>
      </div>

      <div className="flex w-full flex-col items-center justify-center gap-4">
        {projectsData.map((project) => (
          <ProjectCard key={project.title} project={project} />
        ))}
      </div>
    </motion.section>
  );
}
